export default function Hero() {
  const handleScrollTo = (e: React.MouseEvent<HTMLAnchorElement>, targetId: string) => {
    e.preventDefault();
    const target = document.querySelector(targetId);
    if (target) {
      target.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="hero" className="relative min-h-[600px] md:min-h-[700px] flex items-center overflow-hidden bg-background-50">
      <div className="absolute inset-0 bg-gradient-to-br from-primary-50/60 via-background-50 to-accent-50/40"></div>

      <div className="relative w-full max-w-[1280px] mx-auto px-4 md:px-6 py-20 md:py-24">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 w-full text-center lg:text-left">
            <span className="inline-block px-4 py-1.5 text-xs font-semibold tracking-wide text-primary-700 bg-primary-100 rounded-full mb-5">
              免费看片 · 全民共享
            </span>

            <h1 className="font-heading text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold text-foreground-950 leading-tight">
              91免费
              <br />
              <span className="text-primary-500">免费看片软件与视频播放平台</span>
            </h1>

            <p className="mt-5 text-sm md:text-base text-foreground-600 leading-relaxed max-w-xl mx-auto lg:mx-0">
              提供91免费看片app最新版本下载，覆盖安卓、苹果双平台与电脑端。
              每日更新热门视频资源，精选全网免费看片软件推荐，支持高清流畅播放与离线缓存。
              无论你是追剧达人还是随便看看，91免费客户端都能让你即刻拥有稳定、安全的免费看片体验。
            </p>

            <div className="mt-6 flex flex-wrap items-center justify-center lg:justify-start gap-5 text-sm text-foreground-500">
              <span className="flex items-center gap-1.5">
                <span className="w-2 h-2 rounded-full bg-accent-500"></span>
                每日资源更新
              </span>
              <span className="flex items-center gap-1.5">
                <span className="w-2 h-2 rounded-full bg-accent-500"></span>
                双平台全覆盖
              </span>
              <span className="flex items-center gap-1.5">
                <span className="w-2 h-2 rounded-full bg-accent-500"></span>
                千万用户信赖
              </span>
            </div>

            <div className="mt-8 flex flex-wrap items-center justify-center lg:justify-start gap-3">
              <a
                href="#app"
                onClick={(e) => handleScrollTo(e, '#app')}
                className="inline-flex items-center gap-2 px-6 py-3 bg-primary-500 text-background-50 font-semibold text-sm rounded-lg hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
              >
                <i className="ri-download-2-line text-lg"></i>
                立即下载客户端
              </a>
              <a
                href="#ranking"
                onClick={(e) => handleScrollTo(e, '#ranking')}
                className="inline-flex items-center gap-2 px-6 py-3 bg-background-100 text-foreground-800 font-medium text-sm rounded-lg hover:bg-background-200 transition-colors border border-background-200 whitespace-nowrap cursor-pointer"
              >
                <i className="ri-fire-line text-lg"></i>
                查看热门榜单
              </a>
            </div>
          </div>

          <div className="flex-1 w-full flex justify-center lg:justify-end">
            <div className="relative w-[280px] h-[480px] sm:w-[320px] sm:h-[540px] md:w-[360px] md:h-[580px] rounded-2xl overflow-hidden bg-background-100 border border-background-200/70">
              <img
                src="https://readdy.ai/api/search-image?query=A%20modern%20smartphone%20floating%20in%20front%20of%20a%20clean%20minimal%20background%2C%20showing%20a%20video%20streaming%20app%20interface%20with%20movie%20thumbnails%20in%20a%20grid%20layout%2C%20warm%20ambient%20lighting%2C%20soft%20gradient%20background%20with%20coral%20and%20cream%20tones%2C%20modern%20UI%20design%2C%20high%20quality%203D%20render%2C%20editorial%20product%20photography%20style%20with%20clean%20composition&width=720&height=1160&seq=hero-phone-2026&orientation=portrait"
                alt="91免费看片app手机端界面展示"
                className="w-full h-full object-cover object-top"
              />
              <div className="absolute inset-0 rounded-2xl border-2 border-background-200/30 pointer-events-none"></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}